/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { UniversalPortal } from '@jesstelford/react-portal-universal'
import { SecondaryButton, TertiaryButton } from 'common/button'
import { IoMdSend } from 'react-icons/io'
import formatEditorText from 'utils/format-editor'
import autoHeight from 'utils/textarea-autoheight'
import { FormStyled, FormCommentStyled } from 'components/comment/form/form-styled'
import { useLesson } from 'querys/lesson'
import { useUsers } from 'querys/comments'
import { useCreateComment } from 'mutations/comments'
import Overlay from 'common/Overlay'
import useSession from 'querys/session'
import Participants from './participants'

function FormComment({
  handleActive, autofocus, parent, cta, placeholder, participants,
}) {
  const { data: { has_access: hasAccess }, token } = useLesson()
  const createComment = useCreateComment()
  const { profile: user } = useSession()
  const [comment, setComment] = useState('')
  const [mention, setMention] = useState(false)
  const [arroba, setArroba] = useState('')
  const { data } = useUsers({ initial: participants, arroba })
  const [buttons, setButtons] = useState(false)
  const [isOverlayActive, setisOverlayActive] = useState(false)
  const [formSize, setformSize] = useState(61)
  const [focus, setFocus] = useState(false)
  const [visualViewport, setVisualViewport] = useState(0)
  const [resize, setResize] = useState(false)
  const element = useRef(null)
  const textAreaRef = useRef(null)

  function handleSubmit(event) {
    if (event) {
      event.preventDefault()
    }
    // console.log(data)
    if (!comment || !data) return
    const commentContent = formatEditorText(comment, data)
    createComment.mutate({ comment: commentContent, parent, participants: data })
    setComment('')
    if (handleActive) { handleActive() }
    textAreaRef.current.style.cssText = 'height:auto;'
  }

  function cancelMessage() {
    if (handleActive) { handleActive() }
    setButtons(false)
    setComment('')
  }

  function handleKeyEnter(event) {
    if (event.which === 13) {
      // handleSubmit(event)
      // if (window.matchMedia('(max-width: 768px)').matches) {
      //   event.target.blur()
      // }
      // event.target.style.height = 'auto'
    }
  }

  function closeOverlay() {
    if (handleActive) { handleActive() }
    setisOverlayActive(false)
    setFocus(false)
    setResize(false)
  }

  function handleFocus() {
    setFocus(true)
    setResize(false)
    if (window.matchMedia('(min-width: 768px)').matches) {
      setButtons(true)
      setisOverlayActive(false)
    } else {
      setformSize(element?.current?.offsetHeight)
      setButtons(false)
      setisOverlayActive(true)
    }
  }

  function handleBlur() {
    setFocus(false)
    setisOverlayActive(false)
    setformSize(61)
    if (window.matchMedia('(max-width: 768px)').matches && comment) {
      handleSubmit()
    }
  }
  function checkScroll() {
    if (focus && resize && document.documentElement.scrollTop > 100) {
      document.documentElement.scrollTop = 100
    }
  }

  const handleComment = (str) => {

    if (mention) {
      setArroba(str.slice(str.lastIndexOf('@') + 1))
    }

    if (str.slice(-1) === '@') {
      setMention(true)
    } else if (mention && str.slice(-1) === ' ') {
      setArroba('')
      setMention(false)
    }
    setComment(str)
  }

  useEffect(() => {
    if (focus && resize) {
      setTimeout(() => {
        checkScroll()
      }, 100)
    }
  }, [focus, resize])

  useEffect(() => {
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => {
        setVisualViewport(window.visualViewport.height)
        if (!window.matchMedia('(min-width: 768px)').matches) {
          setResize(true)
        }
      })
      return
    }
    window.addEventListener('resize', () => {
      setVisualViewport(window.innerHeight)
      if (!window.matchMedia('(min-width: 768px)').matches) {
        setResize(true)
      }
    })
  }, [])
  useEffect(() => {
    if (!element.current) return
    try {
      Promise.resolve(
        typeof window.ResizeObserver !== 'undefined'
          ? window.ResizeObserver
          : import('resize-observer-polyfill'),
      ).then((Observer) => {
        const resizeObserver = new Observer((entries) => {
          setformSize(entries[0].target.offsetHeight)
        })
        resizeObserver.observe(element.current)
      })
    } catch (err) {
      console.error(err)
    }
  }, [])

  const blurAndSumbit = () => {
    setFocus(false)
    setisOverlayActive(false)
    setformSize(61)
    if (window.matchMedia('(max-width: 768px)').matches && comment) {
      handleSubmit()
    }
  }

  if (!token || !hasAccess) return null

  return (
    <div>
      <UniversalPortal selector="#page-portal">
        <Overlay onClick={closeOverlay} isActive={isOverlayActive && resize} />
      </UniversalPortal>
      <FormCommentStyled data-cy="comment-form">
        <FormStyled
          ref={element}
          onSubmit={blurAndSumbit}
          size={formSize}
          focusOnMobile={focus && resize}
          visualViewport={visualViewport}
          disabled={!comment && true}
        >
          <figure className="avatar">
            <img
              width="40"
              height="40"
              src={user.photo || '/icons/icon-50x50.png'}
              alt={`${user.first_name} ${user.last_name}`}
            />
          </figure>
          <textarea
            onKeyDown={autoHeight}
            onKeyPress={handleKeyEnter}
            placeholder={placeholder}
            rows="1"
            autoComplete="off"
            ref={textAreaRef}
            value={comment}
            onChange={(event) => handleComment(event.target.value)}
            autoFocus={autofocus}
            onFocus={handleFocus}
            // onBlur={handleBlur}
          />
          <button type="submit" className="submit">
            <IoMdSend size={25} color="var(--secondary)" />
          </button>
        </FormStyled>
        <Participants
          comment={comment}
          mention={mention}
          arroba={arroba}
          participants={participants}
          setComment={setComment}
          setMention={setMention}
        />
        <div className="mardown-activated">
          <span>Markdown activado</span>
        </div>
        {buttons && (
          <div className="actions">
            <TertiaryButton
              width="133px"
              onClick={cancelMessage}
              font="var(--secondaryFont)"
            >
              Cancelar
            </TertiaryButton>
            <SecondaryButton
              activeBackground={!comment ? 'var(--primaryDisabled)' : 'var(--primaryHover)'}
              clickedBackground={!comment ? 'var(--primaryDisabled)' : 'var(--primaryActive)'}
              disabled={!comment && true}
              color={!comment ? 'var(--baseSecondary)' : 'var(--basePrimary)'}
              fontWeight={500}
              onClick={handleSubmit}
              width="148px"
            >
              {cta}
            </SecondaryButton>
          </div>
        )}
      </FormCommentStyled>
    </div>
  )
}

FormComment.defaultProps = {
  handleActive: null,
  autofocus: false,
  parent: null,
  index_comment: null,
}

FormComment.propTypes = {
  handleActive: PropTypes.func,
  autofocus: PropTypes.bool,
  parent: PropTypes.string,
  index_comment: PropTypes.number,
  cta: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
}

export default FormComment
